import { render, staticRenderFns } from "./TourGrid1x1.vue?vue&type=template&id=ef170dcc&scoped=true&"
import script from "./TourGrid1x1.vue?vue&type=script&lang=js&"
export * from "./TourGrid1x1.vue?vue&type=script&lang=js&"
import style0 from "./TourGrid1x1.vue?vue&type=style&index=0&id=ef170dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef170dcc",
  null
  
)

export default component.exports